import { createAction } from 'typesafe-actions';
import { ITrapType } from '../../../../types/model/masterData/trap/trapType';

export default class TrapTypeActions {
    public static setLoading = createAction('MASTER_DATA_TRAP_TYPE_SET_LOADING', resolve => (loading : boolean) => resolve(loading));
    public static setList = createAction('MASTER_DATA_TRAP_TYPE_SET', resolve => (blocks : Array<ITrapType>) => resolve(blocks));
}